module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/hollywood_2x.39a8ce6.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/hollywood_2x.png
// module id = yl2w
// module chunks = 41